//
//
//
//
//
//

export default {
  data () {
    return { }
  },
  beforeCreate () {
    this.addon.pageReady(this)
  },
  mounted () {
    this.getPageSize()
    window.onresize = () => {
      this.getPageSize()
    }
  },
  methods: {
    // 获取页面尺寸
    getPageSize () {
      let bodyHeight = document.documentElement.offsetHeight
      let bodyWidth = document.documentElement.offsetWidth
      this.$store.dispatch('updatePageInfo', { bodyHeight, bodyWidth })
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.vue